import { getRouteApi } from '@tanstack/react-router';

const { useLoaderData } = getRouteApi('/blood-report/_role-guard/$id');

export function useBloodReportLoaderData() {
  const { bloodReport, carePlanId, patient } = useLoaderData();

  return { bloodReport, carePlanId, patient };
}
